import type { LucideIcon } from 'lucide-react';
import { BarChart3, ClipboardList, Gauge, Library, Settings2, Table2 } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Lane that owns the pages behind this entry. */
  owner: 'registry' | 'governance' | 'admin' | 'library';
  /** Hidden from the sidebar unless the signed-in user has one of these roles. */
  roles?: string[];
  description: string;
}

/**
 * The shell's navigation contract. Each feature lane mounts its own <Routes> under its base
 * path (see src/app/routes.tsx), so adding a page inside a lane never touches this file.
 */
export const NAV_ITEMS: NavItem[] = [
  {
    to: '/registry',
    label: 'Registry',
    icon: Table2,
    owner: 'registry',
    description: 'Capabilities by department, maturity and gap',
  },
  {
    to: '/governance/requests',
    label: 'Requests',
    icon: ClipboardList,
    owner: 'governance',
    description: 'Investment requests and their workflow state',
  },
  {
    to: '/governance/queue',
    label: 'Scoring queue',
    icon: Gauge,
    owner: 'governance',
    description: 'Score submitted requests against the active model',
  },
  {
    to: '/governance/dashboard',
    label: 'Dashboard',
    icon: BarChart3,
    owner: 'governance',
    description: 'Maturity, gaps, requests and document coverage',
  },
  {
    to: '/library',
    label: 'Library',
    icon: Library,
    owner: 'library',
    description: 'Specs, policies and research the registry cites',
  },
  {
    to: '/admin',
    label: 'Admin',
    icon: Settings2,
    owner: 'admin',
    roles: ['HeadOfIT', 'Admin'],
    description: 'Attributes, relationships, scoring weights, users',
  },
];
